import { Fragment } from "react"
import { Check, User, Package, CreditCard, Sparkles } from "lucide-react"

const ICONS = [User, Package, CreditCard, Sparkles]

/**
 * @param {{ currentStep: number, labels: string[] }} props
 */
export function SubscriptionStepper({ currentStep, labels }) {
  const n = labels.length

  return (
    <nav aria-label="Étapes de l’abonnement" className="w-full">
      <div className="flex w-full items-center">
        {labels.map((label, i) => {
          const stepNum = i + 1
          const isDone = currentStep > stepNum
          const isCurrent = currentStep === stepNum
          const Icon = ICONS[i] ?? User

          const circleClass = isDone
            ? "border-primary bg-primary text-primary-foreground"
            : isCurrent
              ? "border-primary bg-primary/20 text-primary ring-2 ring-primary/40"
              : "border-border bg-muted text-muted-foreground"

          return (
            <Fragment key={label}>
              <div className="flex min-w-0 flex-col items-center gap-2">
                <div
                  className={`
                    flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 text-sm font-semibold transition-colors
                    ${circleClass}
                  `}
                  aria-current={isCurrent ? "step" : undefined}
                >
                  {isDone ? <Check className="h-5 w-5" strokeWidth={2.5} /> : <Icon className="h-5 w-5" />}
                </div>
                <span
                  className={`
                    max-w-[4.75rem] text-center text-[11px] font-medium leading-tight sm:max-w-[6rem] sm:text-xs
                    ${isCurrent ? "text-foreground" : "text-muted-foreground"}
                  `}
                >
                  {label}
                </span>
              </div>
              {i < n - 1 && (
                <div
                  className={`mx-0.5 h-0.5 min-w-[0.75rem] flex-1 self-center sm:mx-2 ${currentStep > i + 1 ? "bg-primary/70" : "bg-border"}`}
                  aria-hidden
                />
              )}
            </Fragment>
          )
        })}
      </div>
    </nav>
  )
}
